var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"autoClose":true,"large":_vm.large,"extraLarge":_vm.extraLarge},on:{"closeMe":_vm.closeSlidebar}},[_c('CopyGraderuleTerm',{attrs:{"id":_vm.id,"isCreating":false,"divisionId":_vm.divisionId},on:{"finishCopy":function($event){return _vm.closeSlidebar()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }